import { Grid, styled } from "@mui/material";

import Select from "components/Select";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

function BrokerSelect() {
  const { setValue, watch } = useFormContext();
  const brokerId = watch("brokerId");
  const basketId = watch("basketId")

  const [searchParams, setSearchParams] = useSearchParams();

  const tradeInsertForm = useSelector(
    (state) => state.trade?.tradeInsertForm?.data
  );

  const brokerListFiltered = useMemo(() => {
    const brokers = tradeInsertForm?.lisBroker.filter(
      (item) => +item.basketId === +basketId
    );

    return brokers
  }, [basketId, tradeInsertForm]);

  const handleChange = (e) => {
    const val = e?.target?.value;

    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, brokerId: val });

    setValue("brokerId", val);
    setValue("price", '');
    setValue("amount", '');
  };

  return (
    <Grid container mb={1}>
      <Grid item xs={12}>
        <SelectStyle
          items={brokerListFiltered}
          itemValue="brokerId"
          itemText="broker"
          justifyContent="center"
          value={brokerId}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
}

const SelectStyle = styled(Select)(({ theme }) => ({
  textAlign: "center",
  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 2.5),
    fontSize: "12px",
  },
}));

export default BrokerSelect;
